<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="stockAdjustment.id?true:false"
                >
                  <v-text-field
                    slot="activator"
                    label="IssueDate"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker v-model="issueDate" :rules="rules.issueDateRules"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
                <v-autocomplete
                  v-model="stockAdjustment.warehouseName"
                  :items="warehouseList"
                  color="blue-grey lighten-2"
                  label="Choose Warehouse..."
                  item-text="name"
                  menu-props="auto"
                  item-value="name"
                  :readonly="stockAdjustment.id?true:false"
                  :rules="rules.warehouseRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12 v-if="user.role.roleName == 'WAREHOUSE_MANAGER'">
                <v-text-field
                  label="Warehouse Name"
                  v-model="warehouseName"
                  type="text"
                  :readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex sm12>
                <v-autocomplete
                  v-model="stockAdjustment.status"
                  :items="stockAdjustmentTypeList"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  menu-props="auto"
                  item-value="value"
                  :readonly="stockAdjustment.id?true:false"
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="stockAdjustment.description"
                  type="text"
                  :rules="rules.descriptionRuless"
                  :readonly="stockAdjustment.id?true:false"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="stockAdjustment.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="stockAdjustment.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="stockAdjustment.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="stockAdjustment.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="stockAdjustment.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="stockAdjustment.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="addStockAdjustmentItem()"
                    :disabled="stockAdjustment.id?true:false"
                  >
                    Add StockIn Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs2>Code</v-flex>
                  <v-flex xs3>Product</v-flex>
                  <v-flex xs2>Unit</v-flex>
                  <v-flex xs2>Qty</v-flex>
                  <v-flex xs2>Remark</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(stockAdjustmentItem, index) in stockAdjustment.stockAdjustmentItems"
                  :key="index"
                >
                  <v-flex xs2>
                    <v-text-field
                      v-if="stockAdjustment.id ? true : false"
                      placeholder="Select the code"
                      v-model="stockAdjustmentItem.productCode"
                      readonly
                      :rules="rules.codeRules"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      placeholder="Select the code"
                      v-model="stockAdjustmentItem.productCode"
                      @click="showProducts(), selectedIndex = index"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      v-model="stockAdjustmentItem.productName"
                      :loading="showAutocompleteLoading"
                      label="Product"
                      :readonly="true"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-autocomplete
                      v-model="stockAdjustmentItem.factorUnitName"
                      :loading="showAutocompleteLoading"
                      :hide-no-data="true"
                      :items="stockAdjustmentItem.productUnits"
                      color="blue-grey lighten-2"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      menu-props="auto"
                      :readonly="stockAdjustment.id?true:false"
                      label="Select"
                      :rules="rules.unitRules"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="stockAdjustmentItem.qty"
                      type="number"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :rules="rules.qtyRules"
                      :readonly="stockAdjustment.id?true:false"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="stockAdjustmentItem.remark"
                      type="text"
                      :rules="rules.remarkRules"
                      :readonly="stockAdjustment.id?true:false"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1 v-if="stockAdjustment.id">
                    <v-btn
                      icon
                      @click="removeStockAdjustmentItem(index, stockAdjustment.id)"
                      disabled
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs1 v-else>
                    <v-btn
                      icon
                      v-if="index === 0"
                      @click="removeStockAdjustmentItem(index, stockAdjustment.id)"
                      disabled
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      v-else
                      @click="removeStockAdjustmentItem(index, stockAdjustment.id)"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear" :disabled="stockAdjustment.id?true:false">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    type="submit"
                    :disabled="btnDisabled || saveLoading"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="setProduct(props.item.code, selectedIndex), showProductListDialog = !showProductListDialog"
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">{{ props.item.productGroup.name }}</td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { warehouseService } from "../../services/warehouse-service";
import { productService } from "../../services/product-service";
import { commonService } from "../../services/common-service";
import { StockAdjustmentFormRules } from "../../helpers/validation-rules";
import { StockAdjustment, StockAdjustmentItem } from "../../models/model";
import { stockAdjustmentService } from "../../services/stock-adjustment-service";

export default {
  name: "StockAdjustmentDetail",
  components: {},

  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "StockAdjustment",
        disabled: false,
        to: "stock-adjustments"
      },
      {
        text: "StockAdjustment Detail",
        disabled: true
      }
    ],
    createdDate: "",
    updatedDate: "",
    issueDate: "",
    warehouseName: "",
    stockAdjustment: new StockAdjustment(),
    oldStockAdjustment: new StockAdjustment(),
    stockAdjustmentItem: new StockAdjustmentItem(),
    warehouseList: [],
    productList: [],
    rules: new StockAdjustmentFormRules(),
    responseError: "",
    btnDisabled: false,
    saveLoading: false,
    showAutocompleteLoading: false,
    stockAdjustmentTypeList: [
      { label: "DAMAGE", value: "DAMAGE" },
      { label: "LOSS", value: "LOSS" },
      { label: "RE_FOUNDED", value: "RE_FOUNDED" }
    ],
    showProductListDialog: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" }
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0
    },
    totalRows: 0,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: ""
    },
    search: null,
    code: "",
    showListLoading: false,
    selectedIndex: 0
  }),

  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true
    }
  },

  created() {
    if (this.user.role.roleName == "ADMIN" || this.user.role.roleName == "BRANCH_ADMIN") {
      this.getWarehouseList();
    }
    this.warehouseName = this.user.warehouseName;

    if (this.user.role.roleName == "WAREHOUSE_MANAGER") {
      this.stockAdjustment.warehouseName = this.user.warehouseName;
    }

    const id = this.$route.params.id;
    if (id == "new") {
      // new stockin
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
      this.addStockAdjustmentItem();
    } else {
      this.getStockAdjustmentDetail(id);
    }
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },

    getWarehouseList() {
      warehouseService
        .getAllWarehouse("ACTIVE")
        .then(res => {
          let tempList = res.data;
          for (let temp of tempList) {
            this.warehouseList.push(temp);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    getStockAdjustmentDetail(id) {
      stockAdjustmentService
        .getStockAdjustmentDetail(id)
        .then(res => {
          this.stockAdjustment = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.stockAdjustment.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.stockAdjustment.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.btnDisabled = true;
          this.issueDate = commonService.millisecondToDate(
            this.stockAdjustment.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          // deep copy
          this.oldStockAdjustment = JSON.parse(JSON.stringify(res.data));
        })
        .catch(err => {
          console.log(err);
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        //convert to millisecond
        this.stockAdjustment.issueDateInMilliSeconds = commonService.convertToMilliseconds(
          this.issueDate
        );

        stockAdjustmentService
          .saveStockAdjustment(this.stockAdjustment)
          .then(res => {
            if (res) {
              this.goBack();
            }
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },

    goBack() {
      this.$router.push("/stock-adjustments");
    },

    addStockAdjustmentItem() {
      // deep copy
      stockAdjustmentItem = new StockAdjustmentItem();
      let stockAdjustmentItem = JSON.parse(
        JSON.stringify(this.stockAdjustmentItem)
      );
      this.stockAdjustment.stockAdjustmentItems.push(stockAdjustmentItem);
    },

    removeStockAdjustmentItem(index, stockAdjustmentItemId) {
      if (stockAdjustmentItemId) {
        // add delete stock in id
        if (!this.stockAdjustment.deleteStockAdjustmentItemIds) {
          this.stockAdjustment.deleteStockAdjustmentItemIds = [];
        }
        this.stockAdjustment.deleteStockInItemIds.push(stockAdjustmentItemId);
      }
      this.$delete(this.stockAdjustment.stockAdjustmentItems, index);
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.stockAdjustment.id) {
        this.stockAdjustment = new StockAdjustment();
        this.addStockAdjustmentItem();
      } else {
        this.stockAdjustment = Object.assign({}, this.oldStockAdjustment);
      }
    },

    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    showProducts() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";

      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },

    setProduct(code, index) {
      let product = commonService.search("code", code, this.productList);
      this.stockAdjustment.stockAdjustmentItems[index].productCode =
        product.code;
      this.stockAdjustment.stockAdjustmentItems[index].productName =
        product.name;
      this.stockAdjustment.stockAdjustmentItems[index].factorUnitName = "";
      this.stockAdjustment.stockAdjustmentItems[index].productUnits =
        product.productUnits;
      this.stockAdjustment.stockAdjustmentItems[index].unitCost = 0;
      this.stockAdjustment.stockAdjustmentItems[index].sellingPrice = 0;
    }
  }
};
</script>

